import React from 'react';
import { DataSourceConfiguration } from '@/components/admin/DataSourceConfiguration';

/**
 * Step 2 — Data Sources (TYPE A: Recommended Configuration)
 *
 * Embeds the real DataSourceConfiguration page directly.
 * onNavigate is passed as a no-op to prevent navigation away from the assistant.
 * All changes are immediately persisted.
 * No empty state — page shown directly (Type A).
 */
export const StepDataSources: React.FC = () => {
  // No-op: prevents DataSourceConfiguration from navigating away mid-flow
  const noOpNavigate = () => {};

  return (
    <div className="p-6 h-full">
      <div className="rounded-lg border border-border bg-white overflow-auto max-h-[calc(100vh-200px)]">
        <DataSourceConfiguration onNavigate={noOpNavigate} />
      </div>
    </div>
  );
};
